import { render, staticRenderFns } from "./AgentMenu.vue?vue&type=template&id=554b5f14&scoped=true&"
import script from "./AgentMenu.vue?vue&type=script&lang=js&"
export * from "./AgentMenu.vue?vue&type=script&lang=js&"
import style0 from "./AgentMenu.vue?vue&type=style&index=0&id=554b5f14&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554b5f14",
  null
  
)

export default component.exports